import { render, staticRenderFns } from "./VersionAlert.vue?vue&type=template&id=7943922a&"
import script from "./VersionAlert.vue?vue&type=script&lang=js&"
export * from "./VersionAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports